import { Api } from "../../common/lib/httpRequest";
import {
  PostCreatePaymentRequest,
  CreatePaymentResponse
} from "../utils/types";

export const apiCreatePayment = (package_id: PostCreatePaymentRequest): Promise<CreatePaymentResponse> => {
  return Api.post(`api/v1/user/subscriptions/subscribe/${package_id}`);
};
